import axiosInstance from '@/lib/axiosInstance';

export const sendForm = (data, params) => {
  return axiosInstance.post('/tytum/public/contact-us', data, {
    baseURL: 'https://api-app.orcatec.com/api/v1.0',
    params,
  });
};
